import { render } from "./GridLoader.vue?vue&type=template&id=00b3499e&scoped=true"
import script from "./GridLoader.vue?vue&type=script&lang=js"
export * from "./GridLoader.vue?vue&type=script&lang=js"

import "./GridLoader.vue?vue&type=style&index=0&id=00b3499e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hairwizard/hairwizard/hwappointments/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b3499e"]])

export default __exports__